function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.3335 14.832H1.00016C0.823352 14.832 0.653783 14.7618 0.528758 14.6368C0.403734 14.5117 0.333496 14.3422 0.333496 14.1654V3.4987C0.333496 3.32189 0.403734 3.15232 0.528758 3.02729C0.653783 2.90227 0.823352 2.83203 1.00016 2.83203H2.3335",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 2.83203H10.3333C10.5101 2.83203 10.6797 2.90227 10.8047 3.02729C10.9298 3.15232 11 3.32189 11 3.4987V5.83203",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.6665 2.83203C6.21879 2.83203 6.6665 2.38432 6.6665 1.83203C6.6665 1.27975 6.21879 0.832031 5.6665 0.832031C5.11422 0.832031 4.6665 1.27975 4.6665 1.83203C4.6665 2.38432 5.11422 2.83203 5.6665 2.83203Z",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.61016 2.16797H8.3335C8.51031 2.16797 8.67988 2.23821 8.8049 2.36323C8.92992 2.48826 9.00016 2.65782 9.00016 2.83464V3.5013C9.00016 3.67811 8.92992 3.84768 8.8049 3.97271C8.67988 4.09773 8.51031 4.16797 8.3335 4.16797H3.00016C2.82335 4.16797 2.65378 4.09773 2.52876 3.97271C2.40373 3.84768 2.3335 3.67811 2.3335 3.5013V2.83464C2.3335 2.65782 2.40373 2.48826 2.52876 2.36323C2.65378 2.23821 2.82335 2.16797 3.00016 2.16797H4.7235",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.9998 15.5013C14.9998 15.6781 14.9296 15.8477 14.8046 15.9727C14.6796 16.0977 14.51 16.168 14.3332 16.168H8.33317C8.15636 16.168 7.98679 16.0977 7.86177 15.9727C7.73674 15.8477 7.6665 15.6781 7.6665 15.5013V7.83464C7.6665 7.65782 7.73674 7.48826 7.86177 7.36323C7.98679 7.23821 8.15636 7.16797 8.33317 7.16797H13.0572C13.234 7.16801 13.4035 7.23827 13.5285 7.3633L14.8045 8.6393C14.9295 8.7643 14.9998 8.93384 14.9998 9.11064V15.5013Z",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.6665 10.1641H12.9998",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.6665 12.1641H12.9998",
  stroke: "#5F7483",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0 0.5)"
})));

var SvgCopy = function SvgCopy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCopy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/copy.dcc94ac7.svg";
export { ForwardRef as ReactComponent };